import Joi from "joi";

export default Joi.object({
	username: Joi.string().required(),
	password: Joi.string().required(),
	app_key: Joi.string().required(),
	x_access_key: Joi.string().required(),
	region: Joi.string()
		.valid("europe", "china", "australia", "international")
		.required()
});
